import React from 'react';

class BenchmarkAverages extends React.Component {
  render() {
    if (this.props.data === null) {
      return (
        <div className="percentage-pass">
          <p>Loading...</p>
        </div>
      )
    } else {
      function roundScore(score) {
          const numScore = parseFloat(score);
          return Math.round(numScore * 100);
      }
      const averages = this.props.data;
      const percentagePass = Object.keys(averages).map(function(testType) {
          let chartValue = roundScore(averages[testType]);
          const chartLabel = testType;
          const chartIndex = testType;

          // Don't show progessive web app score.
          if (chartLabel === 'pwa') {
              return false;
          }

          if (isNaN(chartValue)) {
            chartValue = 0;
          }

          let scoreClass = "";
          if (chartValue <= 49) {
            scoreClass = "score-red";
          }
          else if (chartValue >= 50 && chartValue <= 89) {
            scoreClass = "score-orange";
          }
          else if (chartValue >= 90) {
            scoreClass = "score-green";
          }

          let scoreLabel = "";
          if (chartLabel === "performance") {
              scoreLabel = "Perf";
          }
          else if (chartLabel === "best-practices") {
              scoreLabel = "BP";
          }
          else if (chartLabel === "accessibility") {
              scoreLabel = "A11y";
          }
          else if (chartLabel === "seo") {
              scoreLabel = "SEO";
          }


          return <div key={chartIndex} className="score"><span className={scoreClass}>{chartValue}%<br/><span className="score-label">{scoreLabel}</span></span></div>
      });

      return (
          <div className="percentage-pass">
              <p>Percentage of sites tested that pass Kanopi benchmarks</p>
              <div className="scores">
                  {percentagePass}
              </div>
              <div className="notice"><span className="score-green">Great (90+)</span> <span className="score-orange">Average (89 - 50)</span> <span className="score-red">Poor (less than 50)</span></div>
          </div>
      );
    }
  }
}

export default BenchmarkAverages;